import { render, staticRenderFns } from "./SharedShopPage.vue?vue&type=template&id=6dc04de0&"
import script from "./SharedShopPage.vue?vue&type=script&lang=js&"
export * from "./SharedShopPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports